import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

export default function DisclaimerPage() {
  const SITE_URL = __VITE_SITE_URL__;

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">Disclaimer</h1>
          <p className="text-foreground-400 text-sm mb-10">Ultimo aggiornamento: Luglio 2026</p>
          <div className="prose prose-sm text-foreground-600 space-y-6">
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Natura del Sito</h2>
              <p>Questo sito offre informazioni educative relative a Itaobuy Spreadsheet. Non siamo il sito ufficiale Itaobuy e non vendiamo direttamente prodotti. Tutti i link esterni reindirizzano a siti di terze parti sui quali non abbiamo alcun controllo.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Accuratezza delle Informazioni</h2>
              <p>Le informazioni fornite su itaobuyspread.lol hanno scopo puramente informativo. Sebbene ci impegniamo a mantenere i contenuti aggiornati e accurati, non garantiamo la completezza o l&apos;affidabilità delle informazioni pubblicate. Gli utenti sono invitati a verificare sempre le informazioni prima di prendere decisioni di acquisto.</p>
            </section>
            <section>
              <h2 className="font-heading text-xl font-bold text-foreground-800 mb-3">Link Esterni</h2>
              <p>Il nostro sito contiene link a siti web di terze parti. Non siamo responsabili dei contenuti, delle politiche sulla privacy o delle pratiche di tali siti. L&apos;inclusione di un link non implica la nostra approvazione del sito collegato.</p>
            </section>
          </div>
          <Link to="/" className="inline-flex items-center gap-2 mt-10 text-sm text-primary-500 hover:text-primary-600 transition-colors">
            <i className="ri-arrow-left-line"></i> Torna alla Home
          </Link>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Disclaimer — Itaobuy Spreadsheet Italia',
            description: 'Disclaimer di itaobuyspread.lol. Natura del sito, accuratezza delle informazioni, responsabilità sui link esterni.',
            inLanguage: 'it',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Itaobuy Spreadsheet Italia',
              url: SITE_URL,
            },
          }),
        }}
      />
    </div>
  );
}